export default __webpack_public_path__ + "static/media/img-45-drake.55200c99.jpg";